// apps/landing-page/src/lib/course-lessons.ts

interface CourseLessonSource {
  totalLessons: number;
  chapters?: readonly { lessons: readonly unknown[] }[];
}

// The list endpoint sends every course with an empty `chapters`, so only loaded chapters are
// counted; otherwise the stored total stands. Counting the empty array showed "0 Materi" on every card.
export function countLessons(course: CourseLessonSource): number {
  if (!course.chapters?.length) return course.totalLessons;
  return course.chapters.reduce((sum, chapter) => sum + chapter.lessons.length, 0);
}
